import "react-app-polyfill/ie9";
import "react-app-polyfill/stable";
import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import State from "./store/State";
ReactDOM.render(
  <BrowserRouter basename="/">
    <State>
      <App />
    </State>
  </BrowserRouter>,

  document.getElementById("root")
);
